<template>
  <div>
    <v-form @submit.prevent="save">
      <v-card class="px-2">
        <v-card-title>
          <div class="text-subtitle-2">
            <span class="secondary-font font-weight-bold">{{
              $t("account.profile.title")
            }}</span>
          </div>
        </v-card-title>
        <v-card-subtitle class="grey--text text--darken-1"><span class="text-body-1">{{
          $t("account.profile.description")
        }}</span></v-card-subtitle>
        <v-card-text class="mt-4">
          <v-text-field
            :label="$t('security.fields.email.title')"
            outlined
            dense
            append-icon="mdi-at"
            :value="form.email"
            autocomplete="off"
            @input="delayTouch($v.form.email)"
            @blur="$v.form.email.$touch"
            :error-messages="emailErrors"
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            :label="$t('security.fields.phone.title')"
            outlined
            dense
            append-icon="mdi-phone-outline"
            :value="form.phone"
            autocomplete="off"
            class="font-weight-bold"
            @input="delayTouch($v.form.phone)"
            @blur="$v.form.phone.$touch"
            :error-messages="phoneErrors"
          ></v-text-field>
          <v-text-field
            :label="$t('security.fields.first_name.title')"
            outlined
            dense
            append-icon="mdi-account-tie-outline"
            v-model="form.first_name"
            @input="delayTouch($v.form.first_name)"
            @blur="$v.form.first_name.$touch"
            autocomplete="off"
            :error-messages="firstNameErrors"
            class="font-weight-bold"
          ></v-text-field>
          <v-text-field
            :label="$t('security.fields.last_name.title')"
            outlined
            dense
            append-icon="mdi-account-tie-outline"
            v-model="form.last_name"
            @input="delayTouch($v.form.last_name)"
            @blur="$v.form.last_name.$touch"
            autocomplete="off"
            :error-messages="lastNameErrors"
            class="font-weight-bold"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            :loading="loading.save"
            :disabled="$v.form.$invalid"
            text
            color="primary"
          >
            <span class="font-weight-bold">{{ $t("btn.update") }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { required, maxLength, helpers, email } from "vuelidate/lib/validators";
import FormDelayTouchMixin from "./../../mixins/commons/form-delay-touch";
import FormMixin from "./../../mixins/commons/form";
export default {
  mixins: [FormMixin, FormDelayTouchMixin],
  created() {
    this.initForm();
  },
  data: () => ({
    form: {
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
    },
  }),
  validations() {
    return {
      form: {
        first_name: { required, maxLength: maxLength(100) },
        last_name: { required, maxLength: maxLength(100) },
        phone: {
          required,
          regex: helpers.regex(
            "phone",
            /^(237)((6(?:[5-9][0-9]{7}))|((242|243|620)[0-9]{6}))$/
          ),
        },
        email: {
          required,
          email,
        },
      },
    };
  },
  methods: {
    initForm() {
      const profile = this.$auth.user().profile;
      this.form = {
        email: profile.email,
        phone: profile.phone,
        first_name: profile.first_name,
        last_name: profile.last_name,
      };
    },
    getPath() {
      return "/api/profile";
    },
    getData() {
      return this.form;
    },
    preSubmit() {
      this.loading.save = true;
    },
    postSubmit() {
      this.loading.save = false;
      this.$auth.fetch();
    },
    getMessages() {
      return {
        200: this.$t("account.profile.edit.success"),
        400: true,
        500: true,
      };
    },
  },
  computed: {
    firstNameErrors() {
      const errors = [];
      if (!this.$v.form.first_name.$dirty) return errors;

      if (!this.$v.form.first_name.required)
        errors.push(this.$i18n.t("security.fields.first_name.required"));
      if (!this.$v.form.first_name.maxLength)
        errors.push(
          this.$i18n.t("security.fields.first_name.max_length", {
            max: this.$v.form.first_name.$params.maxLength.max,
          })
        );
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.form.last_name.$dirty) return errors;

      if (!this.$v.form.last_name.required)
        errors.push(this.$i18n.t("security.fields.last_name.required"));
      if (!this.$v.form.last_name.maxLength)
        errors.push(
          this.$i18n.t("security.fields.last_name.max_length", {
            max: this.$v.form.last_name.$params.maxLength.max,
          })
        );
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.form.phone.$dirty) return errors;

      if (!this.$v.form.phone.required)
        errors.push(this.$i18n.t("security.fields.phone.required"));
      if (!this.$v.form.phone.regex)
        errors.push(this.$i18n.t("security.fields.phone.invalid"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.form.email.$dirty) return errors;

      if (!this.$v.form.email.required)
        errors.push(this.$i18n.t("security.fields.email.required"));
      if (!this.$v.form.email.email)
        errors.push(this.$i18n.t("security.fields.email.invalid"));
      return errors;
    },
  },
};
</script>